import { HtmlContentType } from "../enums";

export class HtmlContent {
    id: HtmlContentType;
    htmlData: string;   
}